













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import VueHeader from '@/components/Header.vue';

export default Vue.extend({
  name: 'app',
  components: {
    VueHeader,
  },
  computed: {
    widgetLayoutClass(): string {
      return `widget-${(this as any).widgetLayout}`;
    },
    cssProps(): any {
      return {
        '--primary-color': (this as any).primaryColor,
        '--primary-font-color': (this as any).primaryFontColor,
        '--primary-button-font-color': (this as any).primaryButtonFontColor,
        '--second-color': (this as any).secondColor,
        '--second-font-color': (this as any).secondFontColor,
        '--second-button-font-color': (this as any).secondButtonFontColor,
        '--third-color': (this as any).thirdColor,
        '--third-font-color': (this as any).thirdFontColor,
        '--third-button-font-color': (this as any).thirdButtonFontColor,
        '--fourth-color': (this as any).fourthColor,
        '--fourth-font-color': (this as any).fourthFontColor,
        '--fourth-button-font-color': (this as any).fourthButtonFontColor,
        '--header-background-color': (this as any).headerBackgroundColor,
        '--language-picker-color': (this as any).languagePickerColor,
        '--globe-svg-data-url': `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='420' height='420' stroke='%23${(this as any).languagePickerColor.substr(
          1,
        )}' fill='none'%3E%3Cpath stroke-width='26' d='M209,15a195,195 0 1,0 2,0z'/%3E%3Cpath stroke-width='18' d='m210,15v390m195-195H15M59,90a260,260 0 0,0 302,0 m0,240 a260,260 0 0,0-302,0M195,20a250,250 0 0,0 0,382 m30,0 a250,250 0 0,0 0-382'/%3E%3C/svg%3E")`,
      };
    },
  },
});
